export const OnErrorSad = () => (
  <>
    <path
      d="M22.2,21.8H1.8C0.8,21.8,0,21,0,20V4c0-1,0.8-1.8,1.8-1.8h20.5C23.2,2.2,24,3,24,4v16C24,21,23.2,21.8,22.2,21.8z M1.8,3.7
	C1.6,3.7,1.5,3.9,1.5,4v16c0,0.1,0.1,0.2,0.2,0.2h20.5c0.1,0,0.2-0.1,0.2-0.2V4c0-0.1-0.1-0.2-0.2-0.2H1.8z"
    />
    <path d="M8.2,11c-0.4,0-0.8-0.3-0.8-0.8V8.2c0-0.4,0.3-0.8,0.8-0.8S9,7.8,9,8.2v2.1C9,10.7,8.7,11,8.2,11z" />
    <path d="M15.8,11c-0.4,0-0.8-0.3-0.8-0.8V8.2c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v2.1C16.5,10.7,16.2,11,15.8,11z" />
    <path
      d="M6,16.9c-0.1,0-0.3,0-0.4-0.1c-0.4-0.2-0.5-0.7-0.2-1c1.4-2.2,3.9-3.5,6.5-3.3c2.6-0.1,5.1,1.2,6.8,3.3
	c0.3,0.3,0.2,0.8-0.1,1.1c-0.3,0.3-0.8,0.2-1.1-0.1c-1.3-1.7-3.4-2.8-5.6-2.7c-2.1-0.1-4.1,0.9-5.2,2.6C6.5,16.8,6.2,16.9,6,16.9z"
    />
  </>
);
